// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"ef46b29f","787":"a4f0f019"}[chunkId] + ".chunk.js";
};